$(document).ready(function() { 
  $(window).scroll(function(){
      if ($(this).scrollTop() > 50) {
         $('#shopify-section-header').addClass('sticky-header');
      } else {
         $('#shopify-section-header').removeClass('sticky-header');
      }
  }); 
  jQuery('.footer-block--menu h2.footer-block__heading').click(function() { 
      $(this).toggleClass("tab_active");
    });
    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

$(document).on('ready', function() {
  $('.abz-testimonial-slider .responsive').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: false,
    arrows: true,
    prevArrow: '<button class="slick-prev slick-arrow"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17 18a.93.93 0 0 1-.45-.11l-10-5a1 1 0 0 1 0-1.78l10-5a1 1 0 1 1 .9 1.78L9.24 12l8.21 4.11a1 1 0 0 1 .44 1.34A1 1 0 0 1 17 18Z" fill="#030303" class="fill-464646"></path></svg></button>',
    nextArrow: '<button class="slick-arrow slick-next"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7 18a1 1 0 0 1-.89-.55 1 1 0 0 1 .44-1.34L14.76 12 6.55 7.89a1 1 0 1 1 .9-1.78l10 5a1 1 0 0 1 0 1.78l-10 5A.93.93 0 0 1 7 18Z" fill="#030303" class="fill-464646"></path></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]    
  });

  $('.abz-after-before-slider  .responsive').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    prevArrow: '<button class="slick-prev slick-arrow"><svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 48 48"><g id="invisible_box" data-name="invisible box"><rect id="Rectangle_713" data-name="Rectangle 713" width="48" height="48" fill="none"/></g><g id="icons_Q2" data-name="icons Q2"><path id="Path_212" data-name="Path 212" d="M42,24A18,18,0,1,1,24,6,18,18,0,0,1,42,24m4,0a21.9,21.9,0,1,0-6.414,15.586A22,22,0,0,0,46,24Z" fill="#8a969d"/><path id="Path_213" data-name="Path 213" d="M21.8,24l6.6,6.6a1.9,1.9,0,0,1-.2,3,2.1,2.1,0,0,1-2.7-.2l-7.9-8a1.9,1.9,0,0,1,0-2.8l7.9-8a2.1,2.1,0,0,1,2.7-.2,1.9,1.9,0,0,1,.2,3Z" fill="#8a969d"/></g></svg></button>',
    nextArrow: '<button class="slick-arrow slick-next"><svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 48 48"><g id="invisible_box" data-name="invisible box"><rect id="Rectangle_714" data-name="Rectangle 714" width="48" height="48" fill="none"/></g><g id="icons_Q2" data-name="icons Q2"><path id="Path_214" data-name="Path 214" d="M6,24A18,18,0,1,1,24,42,18,18,0,0,1,6,24M2,24A21.9,21.9,0,1,0,8.414,8.414,22,22,0,0,0,2,24Z" fill="#8a969d"/><path id="Path_215" data-name="Path 215" d="M26.2,24l-6.6,6.6a1.9,1.9,0,0,0,.2,3,2.1,2.1,0,0,0,2.7-.2l7.9-8a1.9,1.9,0,0,0,0-2.8l-7.9-8a2.1,2.1,0,0,0-2.7-.2,1.9,1.9,0,0,0-.2,3Z" fill="#8a969d"/></g></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]    
  });

  $('.abz-shr-multicolumn .responsive').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: false,
    prevArrow: '<button class="slick-prev slick-arrow"><svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 48 48"><g id="invisible_box" data-name="invisible box"><rect id="Rectangle_713" data-name="Rectangle 713" width="48" height="48" fill="none"/></g><g id="icons_Q2" data-name="icons Q2"><path id="Path_212" data-name="Path 212" d="M42,24A18,18,0,1,1,24,6,18,18,0,0,1,42,24m4,0a21.9,21.9,0,1,0-6.414,15.586A22,22,0,0,0,46,24Z" fill="#8a969d"/><path id="Path_213" data-name="Path 213" d="M21.8,24l6.6,6.6a1.9,1.9,0,0,1-.2,3,2.1,2.1,0,0,1-2.7-.2l-7.9-8a1.9,1.9,0,0,1,0-2.8l7.9-8a2.1,2.1,0,0,1,2.7-.2,1.9,1.9,0,0,1,.2,3Z" fill="#8a969d"/></g></svg></button>',
    nextArrow: '<button class="slick-arrow slick-next"><svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 48 48"><g id="invisible_box" data-name="invisible box"><rect id="Rectangle_714" data-name="Rectangle 714" width="48" height="48" fill="none"/></g><g id="icons_Q2" data-name="icons Q2"><path id="Path_214" data-name="Path 214" d="M6,24A18,18,0,1,1,24,42,18,18,0,0,1,6,24M2,24A21.9,21.9,0,1,0,8.414,8.414,22,22,0,0,0,2,24Z" fill="#8a969d"/><path id="Path_215" data-name="Path 215" d="M26.2,24l-6.6,6.6a1.9,1.9,0,0,0,.2,3,2.1,2.1,0,0,0,2.7-.2l7.9-8a1.9,1.9,0,0,0,0-2.8l-7.9-8a2.1,2.1,0,0,0-2.7-.2,1.9,1.9,0,0,0-.2,3Z" fill="#8a969d"/></g></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.abz-product-recommendations .responsive').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: false,
    prevArrow: '<button class="slick-prev slick-arrow"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17 18a.93.93 0 0 1-.45-.11l-10-5a1 1 0 0 1 0-1.78l10-5a1 1 0 1 1 .9 1.78L9.24 12l8.21 4.11a1 1 0 0 1 .44 1.34A1 1 0 0 1 17 18Z" fill="#030303" class="fill-464646"></path></svg></button>',
    nextArrow: '<button class="slick-arrow slick-next"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7 18a1 1 0 0 1-.89-.55 1 1 0 0 1 .44-1.34L14.76 12 6.55 7.89a1 1 0 1 1 .9-1.78l10 5a1 1 0 0 1 0 1.78l-10 5A.93.93 0 0 1 7 18Z" fill="#030303" class="fill-464646"></path></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]    
  });
  
  jQuery('[data-youtube], [data-vbg]').youtube_background();
});

$(document).ready(function() {
	var showChar = 180;
    //var ellipsestext = "";
    var moretext = "...Read more";
    var lesstext = "Read less";
    $('.more').each(function() {
        var fullcontent = $(this).html();
        if(fullcontent.length > showChar) {

            var halfcontent = fullcontent.substr(0, showChar);
            console.log(halfcontent)

            var halfhtml = '<halfcontent class="halfcontent">'+halfcontent+'</halfcontent>' 
            var fullhtml = '<fullcontent class="fullcontent">'+fullcontent+'</fullcontent>'
            var morelinkhtml =  '<button href="" class="morelink">'+moretext+'</button>';
            // console.log('KTEST', html)

            $(this).html('');
            $(this).append(halfhtml, fullhtml, morelinkhtml);
        }

    });

    $(".morelink").click(function(){
        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(moretext);
        } else {
            $(this).addClass("less");
            $(this).html(lesstext);
        }
        $(this).parent().toggleClass('show');
        // $(this).prev().toggle();
        return false;
    });       
});
